import React, {  useEffect, useState } from 'react'
import './Intro.css'
import { getDeadlineStatus } from '../../utils/deadlineChecker'

export default function Intro() {
    const [days, setDays] = useState(0);
    const [hours, setHours] = useState(0);
    const [minutes, setMinutes] = useState(0);
    const [seconds, setSeconds] = useState(0);

    useEffect(() => {
        const targetDate = new Date("November 10, 2025 23:59:59").getTime();

        const interval = setInterval(() => {
            const now = new Date().getTime();
            const difference = targetDate - now;

            if (difference <= 0) {
                clearInterval(interval);
            } else {
                const days = Math.floor(difference / (1000 * 60 * 60 * 24));
                const hours = Math.floor(
                    (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
                );
                const minutes = Math.floor(
                    (difference % (1000 * 60 * 60)) / (1000 * 60)
                );
                const seconds = Math.floor((difference % (1000 * 60)) / 1000);
                setDays(days);
                setHours(hours);
                setMinutes(minutes);
                setSeconds(seconds);
            }
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className='intro_component'>
            <img src='hackathon_banner.png' alt='intro' className='intro_pic'></img>

            <div className='intro_sub_component'>

                <p className='bannerHeading1'>Welcome To Hackathon</p>
                <p className='hackathon_name'>EVENT MANAGEMENT CHALLENGE</p>
                {/* <p className='hackathonDate' style={{marginTop:"5px",marginBottom:"0px"}}>Start from 12th Dec 2024</p> */}
                {/* <p className='hackathonDate' style={{marginTop:"0px",paddingTop:"0px"}}>Ends on 16th Jan 2025</p> */}


                <div className='buttonsAndDeadline'>

                    <div className='intro_buttons'>
                        <p className='RegisterNowButtonIntro1' onClick={() => {
                            const status = getDeadlineStatus();
                            if (!status.isOpen) {
                              alert(status.message);
                              return;
                            }
                            window.open('https://www.datavizon.com/course/DataHackathon-4EventManagementChallange-96807', '_blank')
                        }}>Register Now</p>
                        <p className='RegisterNowButtonIntro2' onClick={() => {
                            const status = getDeadlineStatus();
                            if (!status.isOpen) {
                              alert(status.message);
                              return;
                            }
                            window.open('https://forms.office.com/r/96fmWgtsXd', '_blank')
                        }}>Submit Your Entry</p>
                    </div>

                    <div className='countDownSection'>
                        <p className='EndsInText'>Ends In</p>
                        <div className='actualCountDown'>
                            <div className='eachCountDown'>
                                <p className='countDownValueHeading'>{days === 1 ? "Day" : "Days"}</p>
                                <p className='countDownValue'>{days.toString().length === 1 ? "0" : null}{days}</p>
                            </div>
                            <span className='colon'>:</span>

                            <div className='eachCountDown'>
                                <p className='countDownValueHeading'>{hours === 1 ? "Hour" : "Hours"}</p>
                                <p className='countDownValue'>{hours.toString().length === 1 ? "0" : null}{hours}</p>
                            </div>
                            <span className='colon'>:</span>

                            <div className='eachCountDown'>
                                <p className='countDownValueHeading'>{minutes === 1 ? "Minute" : "Minutes"}</p>
                                <p className='countDownValue'>{minutes.toString().length === 1 ? "0" : null}{minutes}</p>
                            </div>
                            <span className='colon'>:</span>
                            
                            <div className='eachCountDown'>
                                <p className='countDownValueHeading'>{seconds === 1 ? "Second" : "Seconds"}</p>
                                <p className='countDownValue'>{seconds.toString().length === 1 ? "0" : null}{seconds}</p>
                            </div>

                        </div>
                    </div>

                </div>

            </div>


        </div>
    )
}
